import { Box, Drawer, MenuItem, Select } from "@mui/material";

export const ScreeningMenuDrawer = ({
  showDrawer,
  onClose,
  languages,
  lang,
  handleLanguageChange,
}: any) => (
  <Drawer
    open={showDrawer}
    onClose={onClose}
    PaperProps={{
      sx: { maxWidth: "100%" },
    }}
  >
    <Box sx={{ p: 2, minWidth: "250px", height: "100%" }}>
      {languages.length > 1 && (
        <Select
          value={lang || "en"}
          onChange={handleLanguageChange}
          id="lang"
          sx={{ height: "48px" }}
          fullWidth
        >
          {languages.map((lang: any) => (
            <MenuItem key={lang.languageCode} value={lang.languageCode}>
              {lang?.languageLabel}
            </MenuItem>
          ))}
        </Select>
      )}
    </Box>
  </Drawer>
);
